import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { columnas } from "./columns"; 

type Entity = models.Usuario;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;  
}

const Disponible = <span className="label label-success"><i className="fa fa-check" />Nombre disponible</span>
const YaExiste = <span className="label label-danger"><i className="fa fa-times" />Nombre no disponible</span>

/**
* Componente para editar un Entity
*/
class UsuarioFormNoRx extends React.PureComponent<Props> {
    private login = (props: Props) => props.value.Login;
    private usuarioExiste = createSelectorRx(this.login, login => resources.Usuario.UsuarioExiste(login));

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        const reglas: validation.Rules<Entity> = {
            Nombre: validation.required,
            Login: validation.required,
            IdPermisos: validation.required,
            IdSucursal: validation.required
        }

        const password: validation.Rules<Entity> = {
            Password: validation.required,
            ConfirmarPassword: x => x.Password == x.ConfirmarPassword
        };

        const usuarioExiste: validation.Rules<Entity> = {
            Login: async () => (await this.usuarioExiste(this.props)) ? "Nombre repetido" : true,
        };

        return validation.andRules(reglas, validation.when(this.cambiarContraseña, password), validation.when(this.props.nuevo, usuarioExiste));
    }


    get cambiarContraseña() {
        return this.props.nuevo || this.props.value.CambiarContraseña || false;
    }
 
 
    // botones de la tabla
    onBorrar = async (x: models.Vendedor) => {
        var listaActual = this.props.value.ListaVendedor; 
        let listaNueva: models.Vendedor[] = []; 
        listaActual.forEach(item => {  
            if(item.IdRegistro!=x.IdRegistro){
                listaNueva.push(item);
            }
         });
         var nuevoEstado: Entity={
            ... this.props.value,
            ListaVendedor : listaNueva
        } 
        this.props.onChange(nuevoEstado);   
    }
 
    AgregarVendedor = async (x: Entity) => {
        var myid= x.IdVendedor == null? 0 :  x.IdVendedor; 
        var consutlaVendedor = await resources.Vendedor.get(myid);  
        var listaActual = this.props.value.ListaVendedor; 
        
        if(listaActual != undefined){
            let listaNueva: models.Vendedor[] = [consutlaVendedor]; 
            listaActual.forEach(item => {  listaNueva.push(item); }); 
            var nuevoEstado: Entity={
                ... this.props.value,
                ListaVendedor : listaNueva
            } 
            this.props.onChange(nuevoEstado);  
        }else{
            let listaNueva: models.Vendedor[] = [consutlaVendedor]; 
            var nuevoEstado: Entity={
                ... this.props.value,
                ListaVendedor : listaNueva
            } 
            this.props.onChange(nuevoEstado);  
        }
    }


    render() {
        const cols = columnas(this); // se cargan las columnas de la tabla
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Password = getField(kea.Password);
        const Rol = getField(selectores.Rol);
        const Sucursal = getField(selectores.Sucursal);
        const Cliente = getField(selectores.Cliente);
        const ChoferZE = getField(selectores.ChoferZE);
        const UsuarioApi = getField(selectores.UsuarioApi);
        const Vendedor = getField(selectores.Vendedor);
        const Direccion = getField(selectores.DireccionClienteSelector);

        const UsuarioZE = getField(selectores.UsuarioZE);

        return (
            <div>
                <kea.Title titulo={(nuevo ? "Nuevo " : "Editar ") + "usuario"} onRegresar={() => history.go("/catalogos/Usuario")} />
                {kea.autogrid(6, [
                    <Text field="Login" />,
                    <Text field="Nombre" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Rol field="IdPermisos" label="Rol" />,
                    <Cliente field="IdCliente" label="Cliente relacionado" />,
                    <Direccion field="IdDireccionOrigen" label="Limitar origen a" idCliente={this.props.value.IdCliente} value={this.props.value.IdDireccionOrigen || undefined}  />,
                    <ChoferZE field="IdChoferZE" label="Chofer zona extendida relacionado" />,
                    <UsuarioZE field="IdUsuarioZE" label="Proveedor Zona extendida" />,
                    <Check field="Habilitado" />,
                    <UsuarioApi field="IdUsuarioApi" label="Usuario API" />,
                    <Vendedor field="IdVendedor" label="Vendedor" /> , 
                    !nuevo && <Check field="CambiarContraseña" />,
                    this.cambiarContraseña && <Password field="Password" label="Contraseña" />,
                    this.cambiarContraseña && <Password field="ConfirmarPassword" label="Confirmar contraseña" />,
                    <Check field="CrearTurnoDiferenteSucursal" />,
                    <Check field="CapturarPesoManualEnDocumentacion" label="Capturar Peso Manual En Documentacion" />,
                ])}

                {false &&  <kea.Button onClick={() => this.AgregarVendedor(this.props.value)}>Agregar Vendedor</kea.Button> }
                {false && <kea.Grid2 columnas={cols} cookieKey={"vendedorListCookieKey2"} items={this.props.value.ListaVendedor} /> }
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const UsuarioForm = componentToRx(UsuarioFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/edit/form.tsx